import React from 'react'
const SectionContext = React.createContext({})


export const SectionProvider = SectionContext.Provider
export default SectionContext
